import MuiThemeProvider from 'libs/material-ui';
import ReactReduxProvider from 'libs/react-redux';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.min.css';
import './App.css';

import InitializeContainer from 'components/common/InitializeContainer';
import ErrorBoundary from 'components/modules/ErrorBoundary';
import PrivateRoute from 'components/modules/PrivateRoute';
import CenterPage from 'pages/Center';
import LinkPage from 'pages/Link';
import LoginPage from 'pages/Login';
import ManagerPage from 'pages/Manager';
import PasswordPage from 'pages/Password';
import RescuePage from 'pages/Rescue';
import ViewerPage from 'pages/Viewer';

const App = () => {
  return (
    <MuiThemeProvider>
      <ReactReduxProvider>
        <BrowserRouter basename={process.env.PUBLIC_URL}>
          <ErrorBoundary label="App">
            <Routes>
              <Route element={<PrivateRoute authentication={false} />}>
                <Route index={true} element={<LoginPage />} />
                <Route path="/change" element={<PasswordPage />} />
              </Route>
              <Route element={<PrivateRoute authentication={true} />}>
                <Route path="/center" element={<CenterPage />} />
                <Route path="/manager" element={<ManagerPage />} />
              </Route>
              <Route path="/link" element={<LinkPage />} />
              <Route path="/client/:role/:room/:phone" element={<RescuePage />} />
              <Route path="/viewer/:room/:key" element={<ViewerPage />} />
            </Routes>
          </ErrorBoundary>
          <InitializeContainer />
          <ToastContainer style={{ zIndex: 100 }} hideProgressBar={true} position="top-center" autoClose={2000} />
        </BrowserRouter>
      </ReactReduxProvider>
    </MuiThemeProvider>
  );
};

export default App;
